import { axios_requer, axios_file } from "../axios/http_axios";
import api_wtl from "@/assets/js/API/api_wtl";
import api_lx from "@/assets/js/API/api_lx";
import api_cjh from "@/assets/js/API/api_cjh";
import api_ldp from "@/assets/js/API/api_ldp";
import api_txtms from "@/assets/js/API/api_txtms";

// path,
// params = {},
// method = 'POST',  //  POST / GET
// headerType = '',  //   json 和 "" 两种
// isShowLoading = true,  //是否显示加载中
// istips = true,        //是否弹窗
// hasSing = false,      //是否有签名

let hasSing = true; //需要签名的加上这个
let method = "GET"; //需要GET请求的加上这个

export default {
  // 公共api

  // 上传文件
  async uploadFile(params) {
    return await axios_file("/base/saas/v1/file/upload", params, "post").then(
      (res) => res
    );
  },
  // 获取租户自定义的表头
  async getGroupFindFieldSort(params) {
    return await axios_requer({
      path: "/v1/admin/customized/getGroupFindFieldSort",
      params,
      method, //加上这个代表是 GET 请求, 不写默认POST
    }).then((res) => res);
  },
  // 保存租户自定义的表头
  async pushFindFieldSort(params) {
    return await axios_requer({
      path: "/v1/admin/customized/pushFindFieldSort",
      params,
      hasSing,
    }).then((res) => res);
  },

  // 公共接口: 各种状态下拉列表接口
  // this.$TOOLS.getStatusValList("print_model_v3.model_type").then((res) => {
  //   console.log(res);
  // });
  // :label="item.showName"
  // :value="item.statusVal"
  // =========== wtl ===========
  // 文件来源单据类型:      file_all_v2.document_status
  // 文件来源单据操作类型:  file_all_v2.document_type
  // 账号状态:  user_v1.user_status
  // 账号类型:  user_type_info_key_v1.user_type
  // 员工状态类型:  organization_employee_v1.employee_status
  // 性别状态类型:  organization_employee_v1.sex
  // 运单状态:  bill_tms_waybill_split_v3.waybill_status
  // 在途状态:  bill_tms_waybill_split_v3.onway_status
  // 外发状态:  bill_tms_waybill_split_v3.outgoing_status
  // 签收情况:  bill_tms_waybill_sign_for_v3.sign_for_situation
  // 运输类型:  bill_tms_transport_task_v3.transport_type
  // 运输计划:  bill_tms_transport_task_v3.transport_plan
  // 运输规划状态:  bill_tms_transport_task_v3.task_status
  // 运输方式:  bill_tms_transport_task_v3.transport_method
  // 提货状态:  bill_tms_waybill_address_v3.take_status
  // 发车类型:  bill_tms_dispatch_v3.departure_type
  // 调度状态:  bill_tms_dispatch_v3.dispatch_status
  // 出入库类型:  bill_tms_waybill_stock_record_v3.operation_type
  // 收回状态:  bill_tms_rnorder_v3.retraction_status
  // 回单状态:  bill_tms_rnorder_v3.return_status
  // 返客户状态:  bill_tms_rnorder_v3.rn_customer_status
  // 单据类型:  bill_tms_waybill_exception_v3.document_status
  // 处理状态:  bill_tms_waybill_exception_v3.handle_status
  // 通知状态:  bill_tms_waybill_expand_v3.notice_status
  // 设备类型:  app_version_v3.device_type
  // 打印模板类型:  print_model_v3.model_type

  async getStatusValList(params) {
    return await axios_requer({
      path: "/common/v1/dict/status/getStatusValList",
      params,
      method,
    }).then((res) => res);
  },
  // 根据字典类型获取字典值下拉列表
  async getConfDictValDownList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/conf/getConfDictValDownList",
      params,
      method,
    }).then((res) => res);
  },
  async getObjectUserDownList(params) {
    return await axios_requer({
      path: "/admin/v3/tms/account/getObjectUserDownList",
      params,
      method,
    }).then((res) => res);
  },

  ...api_wtl,
  ...api_lx,
  ...api_cjh,
  ...api_ldp,
  ...api_txtms
};

